import { TypePolicy } from "@apollo/client";

import type { WatchedSecondsData } from "../../../types/telemetry";
import { makeVarPersisted } from "../utils";

export const volume = makeVarPersisted(50, "PLAYER_VOLUME");
export const autoplay = makeVarPersisted(false, "PLAYER_AUTOPLAY");
export const captions = makeVarPersisted(false, "PLAYER_CAPTIONS");
export const playback = makeVarPersisted(1, "PLAYER_PLAYBACK");
export const quality = makeVarPersisted("auto", "PLAYER_QUALITY");
export const coursebookFontSize = makeVarPersisted(14, "COURSEBOOK_FONTSIZE");
export const courseTab = makeVarPersisted(0, "COURSE_TAB");
export const muted = makeVarPersisted(false, "MUTED");
export const dismissedMessages = makeVarPersisted<string[]>([], "DISMISSED_MESSAGES");
export const mode = makeVarPersisted("", "MODE");
export const sidebarWidth = makeVarPersisted(0, "SIDEBAR_WIDTH");
export const captionLanguage = makeVarPersisted("off", "CAPTION_LANGUAGE");
export const playerWatched = makeVarPersisted<WatchedSecondsData>({}, "PLAYER_WATCHED");

export type ModeType = "light" | "dark";

export const setVolume = (vol: number): void => {
  volume(vol);
};

export const setAutoplay = (isEnabled: boolean): void => {
  autoplay(isEnabled);
};

export const setCaptions = (caps: boolean): void => {
  captions(caps);
};

export const setPlayback = (rate: number): void => {
  playback(rate);
};

export const setQuality = (qual: string): void => {
  quality(qual);
};

export const setCoursebookFontSize = (fontSize: number): void => {
  coursebookFontSize(fontSize);
};

export const setCourseTab = (tab: number): void => {
  courseTab(tab);
};

export const setMuted = (isMuted: boolean): void => {
  muted(isMuted);
};

export const setDismissedMessages = (messages: string[]): void => {
  dismissedMessages(messages);
};

export const setMode = (value: ModeType): void => {
  mode(value);
};

export const setSidebarWidth = (value: number): void => {
  sidebarWidth(value);
};

export const setCaptionLanguage = (language: string): void => {
  captionLanguage(language);
};

export const setPlayerWatched = (data: WatchedSecondsData): void => {
  playerWatched(data);
};

export default {
  fields: {
    volume: {
      read() {
        return volume();
      },
    },
    autoplay: {
      read() {
        return autoplay();
      },
    },
    captions: {
      read() {
        return captions();
      },
    },
    playback: {
      read() {
        return playback();
      },
    },
    quality: {
      read() {
        return quality();
      },
    },
    coursebookFontSize: {
      read() {
        return coursebookFontSize();
      },
    },
    courseTab: {
      read() {
        return courseTab();
      },
    },
    muted: {
      read() {
        return muted();
      },
    },
    dismissedMessages: {
      read() {
        return dismissedMessages();
      },
    },
    mode: {
      read() {
        return mode();
      },
    },
    sidebarWidth: {
      read() {
        return sidebarWidth();
      },
    },
    captionLanguage: {
      read() {
        return captionLanguage();
      },
    },
    playerWatched: {
      read() {
        return playerWatched();
      },
    },
    initCoursePage: {
      keyArgs: ["courseId"],
      merge(existing: unknown, incoming: unknown) {
        // Avoid "Missing field initCoursePage" when responses return {} or null (e.g. errors, empty)
        if (
          incoming === null ||
          incoming === undefined ||
          (incoming !== null && typeof incoming === "object" && Object.keys(incoming).length === 0)
        ) {
          return existing;
        }
        return incoming;
      },
    },
  },
} as TypePolicy;
